// @flow
import { v4 } from 'uuid';

export const inqRandom = () => `k_generated_${v4()}`;